import { FC } from 'react';

import { cn } from 'utils/helpers';

const ChatLoading: FC = () => {
  return (
    <div
      className={cn(
        'w-full h-full py-4 space-y-2',
        'border-b border-separator-primary',
        'scrollbar-thin overflow-y-auto',
      )}
    >
      {[...Array(5)].map((val) => {
        return (
          <div key={val} className="flex odd:flex-row-reverse">
            <div className="animate-pulse h-10 rounded-lg bg-fill-primary px-4 w-1/2"></div>
          </div>
        );
      })}
    </div>
  );
};

export default ChatLoading;
